/**
 * 
 * @file Open With dropdown menu
 * @author Box
 */

import * as React from 'react';
import DropdownMenu from 'box-react-ui/lib/components/dropdown-menu/DropdownMenu';
import Menu from 'box-react-ui/lib/components/menu/Menu';
import OpenWithDropdownMenuItem from './OpenWithDropdownMenuItem';
import MultipleIntegrationsOpenWithButton from './MultipleIntegrationsOpenWithButton';

var OpenWithDropdownMenu = function OpenWithDropdownMenu(_ref) {
    var integrations = _ref.integrations,
        onClick = _ref.onClick;
    return React.createElement(
        DropdownMenu,
        { isRightAligned: true },
        React.createElement(MultipleIntegrationsOpenWithButton, null),
        React.createElement(
            Menu,
            { className: 'bcow-menu' },
            integrations && integrations.map(function (integration) {
                return React.createElement(OpenWithDropdownMenuItem, {
                    integration: integration,
                    onClick: onClick,
                    key: integration.appIntegrationId
                });
            })
        )
    );
};

export default OpenWithDropdownMenu;